import { Layout } from '@/components/Layout';
import { PageHeader } from '@/components/PageHeader';
import { Marketplace } from '@/components/Marketplace';
import { useEnhancedMobile } from '@/hooks/use-enhanced-mobile';
import { useUser } from '@/contexts/UserContext';
import { Navigate } from 'react-router-dom';

const MarketplacePage = () => {
  const { isMobile } = useEnhancedMobile();
  const { accountType } = useUser();

  // Brand users should use the brand dashboard instead
  if (accountType === 'brand') {
    return <Navigate to="/brand-dashboard" replace />;
  }

  return (
    <Layout>
      <PageHeader 
        title="Marketplace." 
        subtitle="Browse and apply to available deals"
      />
      <div className={`container mx-auto max-w-[1200px] overflow-x-hidden ${isMobile ? 'px-2 py-2' : 'px-6 py-6'}`}>
        <Marketplace />
      </div>
    </Layout>
  );
};

export default MarketplacePage;
